import { SearchV2 } from '@cimplico/components';
import NewCalculationTemplateCard from './NewCalculationTemplateCard';
import { useMemo, useState } from 'react';
import { useWorkpaperContext } from '../../providers/WorkpaperProvider';
import { useCalculationTemplates } from '../../queries/resources/calculation-templates';

function NewCalculationForm(): JSX.Element {
    const { id: workpaperId, entity } = useWorkpaperContext();
    const [search, setSearch] = useState<string>();
    const templatesQuery = useCalculationTemplates({
        entityType: [entity.type],
        status: 'PUBLISHED',
        search,
        workpaperId: workpaperId,
    });
    const isLoading = templatesQuery.isLoading;
    const isFetching = templatesQuery.isFetching;
    const templates = useMemo(() => templatesQuery.data?.templates ?? [], [templatesQuery.data?.templates]);
    const [isCreating, setIsCreating] = useState(false);

    return (
        <div className="grid gap-4 grid-cols-[repeat(auto-fill,300px)] w-full max-w-[1000px] mt-4 justify-center">
            <div className="col-span-full">
                <SearchV2 placeholder="Search for a template..." onChange={setSearch} />
            </div>
            {isLoading || isFetching ? (
                <>
                    {[...Array(9).keys()].map((_, i) => {
                        return <div key={i} className="animate-pulse bg-gray-100 h-[125px] rounded"></div>;
                    })}
                </>
            ) : templates.length === 0 ? (
                <div className="col-span-full text-center text-gray-500 py-10">No templates available.</div>
            ) : (
                <>
                    {templates.map((template) => {
                        return (
                            <NewCalculationTemplateCard
                                key={template.id}
                                template={template}
                                disabled={isCreating}
                                onCreating={(): void => setIsCreating(true)}
                                onCreate={(): void => setIsCreating(false)}
                            />
                        );
                    })}
                </>
            )}
        </div>
    );
}

export default NewCalculationForm;
